import { render } from "./CategoriesMenu.vue?vue&type=template&id=fc2da920"
import script from "./CategoriesMenu.js?vue&type=script&lang=js"
export * from "./CategoriesMenu.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__